import React from 'react'
import PropTypes from 'prop-types'

import Header from './Header.jsx'
import { HEADER_THEME } from './constants.js'
import Margin from './Margin.jsx'

import useRect from '../hooks/useRect.js'

// TODO: Card should expose it's inner sizing, as width and height with percents wont work
const Card = (props) => {
  const { title, description, children, showBorder } = props

  const [Rect, rect] = useRect()
  const [InnerRect, innerRect] = useRect()
  const [HeaderRect, headerRect] = useRect()

  const padding = showBorder ? { x: 48, y: 32 } : { x: 0, y: 0 }

  const spacingHeader = title || description ? 48 : 0

  return (
    <svg x={0} y={0} width={'100%'} height={'100%'}>
      <Rect />
      {showBorder && (
        <rect
          x={0}
          width={rect.width}
          y={0}
          height={rect.height}
          fill="transparent"
          stroke="#EBEBEB"
          strokeWidth={2}
          rx={16}
          ry={16}
        />
      )}
      <Margin left={padding.x} top={padding.y} right={padding.x} bottom={padding.y}>
        <InnerRect />
        {(title || description) && (
          <Header
            DelegatedRect={HeaderRect}
            title={title}
            description={description}
            {...HEADER_THEME.CARD}
          />
        )}
        <svg
          x={0}
          width={innerRect.width}
          y={headerRect.height + spacingHeader}
          height={innerRect.height - (headerRect.height + spacingHeader)}
        >
          {children}
        </svg>
      </Margin>
    </svg>
  )
}

Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  showBorder: PropTypes.bool,
}

export default Card
